import css from './SignatureSmallDisplay.module.scss';
import { useEstimateSignature } from '../../context/Appointment/appointment';
import { useLocalization } from '../../context/Localization/localization';

export const SignatureSmallDisplay = () => {
    const estimateSignature = useEstimateSignature();
    const Localization = useLocalization();

    return <div className={css.container}>{estimateSignature && <img src={estimateSignature} alt={Localization.CustomerSignature} />}</div>;
};
